<fa-icon
  kendoPopoverAnchor
  [popover]="markupPopover"
  [showOn]="'hover'"
  class="info"
  [icon]="['fas', 'circle-info']"
></fa-icon>

<kendo-popover #markupPopover>
  <ng-template kendoPopoverTitleTemplate> Whopper Combo (Small) </ng-template>
  <ng-template kendoPopoverBodyTemplate>
    <kendo-gridlayout [gap]="{ rows: 6, cols: 2 }">
      <kendo-gridlayout-item [row]="1" [col]="1"
        >Whopper ALC</kendo-gridlayout-item
      >
      <kendo-gridlayout-item [row]="1" [col]="2"
        >&nbsp;$5.89</kendo-gridlayout-item
      >

      <kendo-gridlayout-item [row]="2" [col]="1"
        >Small Beverage ALC</kendo-gridlayout-item
      >
      <kendo-gridlayout-item [row]="2" [col]="2"
        >&nbsp;$2.59</kendo-gridlayout-item
      >

      <kendo-gridlayout-item [row]="3" [col]="1"
        >Small Side ALC</kendo-gridlayout-item
      >
      <kendo-gridlayout-item [row]="3" [col]="2"
        >&nbsp;$2.79</kendo-gridlayout-item
      >

      <kendo-gridlayout-item [row]="4" [colSpan]="2" [col]="1"
        ><hr
      /></kendo-gridlayout-item>

      <kendo-gridlayout-item [row]="5" [col]="1"
        ><span class="bold-text">Combo Price</span></kendo-gridlayout-item
      >
      <kendo-gridlayout-item [row]="5" [col]="2"
        ><span class="bold-text">&nbsp;$9.29</span></kendo-gridlayout-item
      >

      <kendo-gridlayout-item [row]="6" [col]="1"
        >Combo Discount</kendo-gridlayout-item
      >
      <kendo-gridlayout-item [row]="6" [col]="2">($1.98)</kendo-gridlayout-item>
    </kendo-gridlayout>
  </ng-template>
  <ng-template kendoPopoverActionsTemplate>
    <p class="xsmall-text subtle-text">
      Sample data provided for demonstration purposes
    </p>
  </ng-template>
</kendo-popover>
